module.exports = __webpack_public_path__ + "img/1.9aa4ad90.png";